import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { SPACING } from '../../../../app-v2/design-tokens'

export const StyledBody = styled.div`
    background: ${colors.mayoEggWhite};
`

export const StyledBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${SPACING.XXXL};
    padding-bottom: 64px;
`
